import { useTranslation } from 'react-i18next';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Image from '../../components/Image';

import en from '../../assets/images/lang/english.png';
import de from '../../assets/images/lang/germany.png';

const StyledBox = styled(Box)(({ theme }) => ({
    position: 'fixed',
    bottom: '100px',
    right: '20px',
    zIndex: 1000,
    backgroundColor: "white",
    borderRadius: "50%",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
}));

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '0px', cursor: 'pointer' }} onClick={() => changeLanguage(i18n.language === 'en' ? 'de' : 'en')}>
            <Tooltip title={i18n.language === 'en' ? 'German' : 'English'}>
                <IconButton sx={{ height: '42px', width: '42px', borderRadius: '50%' }} >
                    <Image src={i18n.language !== 'en' ? en : de} style={{ height: '100%', width: '100%', }} />
                </IconButton>
            </Tooltip>
            <Typography sx={{ fontSize: '13px', fontWeight: '500', color: '#000000' }}>{i18n.language !== 'en' ? 'English' : 'German'}</Typography>
        </Box>
    );
};

export default LanguageSwitcher;